const TICK = 1000;

class CountdownSlide extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
      this.timeLeft = this.getAttribute('time-left');
      if(this.timeLeft > 0) {
          this._countdown();
      }
  }

  _countdown() {
      this._tickInterval = setInterval(this._tick.bind(this), TICK);
  }

  _tick() {
     console.log(this.timeLeft);
      if (this.timeLeft <= 0) {
          this._complete();
          return
      }

      this.timeLeft -= TICK;
  }

  _complete() {
      this._tickInterval && clearInterval(this._tickInterval);
      var parentEl = this.closest(".announcement-slider");

      if(this.closest(".flickity-slider")){
        if(this.closest(".flickity-slider").children.length == 1){
          parentEl.closest(".announcement-bar").remove();
        }else{
          var flkty = Flickity.data('#AnnouncementSlider');
          flkty.remove(this)
        }
      }else{
        if(parentEl.children.length == 1){
          parentEl.closest(".announcement-bar").remove();
        }else{
          this.remove();
        }
      }
      
      
  }
}

customElements.define("countdown-slide", CountdownSlide);